<template>
  <modal
    :show="show"
    :disable-backdrop-close="false"
    :show-close-outside-button="false"
    :show-close-button="false"
    class="content-switch-modal"
  >
    <div class="content-switch-modal_container">
      <div class="content-switch-modal_content">
        <span class="content-switch-modal_headline" v-html="$te('VMX.content_switch_modal_headline') ? $t('VMX.content_switch_modal_headline') : 'Bitte wählen Sie:'"/>
        <div class="content-switch-modal_scientific_section">
          <button @click="showSpecificContent('scientific')"> {{ $te('VMX.content_switch_modal_scientific_button') ? $t('VMX.content_switch_modal_scientific_button') : 'Wissenschaft' }} </button>
          <span class="content-switch-modal_description" v-html="$te('VMX.content_switch_scientific_description') ? $t('VMX.content_switch_scientific_description') : 'App mit wissenschaftlichem Programm, ohne Industriesymposien und Ausstellerinformationen'"/>
        </div>
        <div class="content-switch-modal_industry_section">
          <button @click="showSpecificContent('industry')"> {{ $te('VMX.content_switch_modal_industry_button') ? $t('VMX.content_switch_modal_industry_button') : 'Industrie' }} </button>
          <span class="content-switch-modal_description" v-html="$te('VMX.content_switch_industry_description') ? $t('VMX.content_switch_industry_description') : 'App mit wissenschaftlichem Programm, allen Industriesymposien und Ausstellerinformationen'"/>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
import { mapGetters } from 'vuex'
import trackingApi from '~/api/tracking'

import modal from '../index'

export default {
  data() {
    return {
      show: true,
    }
  },
  computed: {
    ...mapGetters({
      event: 'instancesState/getEvent',
      language: 'instancesState/getLanguage',
      instance: 'instancesState/getInstance',
    }),
  },
  methods: {
    showSpecificContent(content) {
      trackingApi.trackCustomAction('content-type-select', '', content)

      localStorage.setItem('content', content)
      localStorage.setItem('hasSeenSplashscreen', true)
      window.location.href = `${window.location.origin}/home/${this.instance}/${this.event}/${this.language}/`
    },
  },
  components: { modal },
}
</script>

<style lang="scss">

  .content-switch-modal {
    .ipl-modal__backdrop {
      background: rgba($color: #fff, $alpha: 0.5);
    }
    .ipl-modal__content {
      max-width: 300px;
      background: rgba($color: #fff, $alpha: 0.8);
      border: 1px solid gray;
      margin:0 1rem;
    }
  }
  .content-switch-modal_container {
    width: 100%;
    .content-switch-modal_content {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 1rem;
      .content-switch-modal_headline {

      }

      .content-switch-modal_scientific_section {
        button {
          background-color: var(--primary);
        }
      }

      .content-switch-modal_industry_section {
        button {
          background-color: var(--primary-industry);
        }
      }

      .content-switch-modal_scientific_section,
      .content-switch-modal_industry_section {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        align-items: center;
        justify-content: center;
        button {
          text-transform: uppercase;
          border-radius: 5px;
          border: none;
          padding: 0.5rem 1rem;
          color: white;
          font-weight: 700;
          min-width: 200px;
        }
        .content-switch-modal_description {
          text-align: center;
        }
      }
    }
  }
</style>
